import { render, staticRenderFns } from "./ModalMatchNewFriend.vue?vue&type=template&id=77c98d75&scoped=true"
import script from "./ModalMatchNewFriend.vue?vue&type=script&lang=js"
export * from "./ModalMatchNewFriend.vue?vue&type=script&lang=js"
import style0 from "./ModalMatchNewFriend.vue?vue&type=style&index=0&id=77c98d75&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c98d75",
  null
  
)

export default component.exports